import type { PropsWithChildren } from 'react';

import { useAppSelector } from '@/store';
import { cn } from '@/utils/cn';

export function ContainerSetter({ children }: PropsWithChildren) {
  const sidebarOpen = useAppSelector((state) => state.ui.sidebarOpen);

  return (
    <main
      className={cn(
        'shell-container',
        sidebarOpen ? 'shell-container--sidebar-open' : 'shell-container--sidebar-closed',
      )}
    >
      {children}
    </main>
  );
}
